/**
 * [#e03fdbc2] Яндекс Метрика. Работает сразу, кроме посетителей, отключивших её в окне cookie.
 * Только публичные страницы: в кабинете есть данные клиентов, Вебвизор туда не подключается.
 */
const COUNTER_ID = 114077674;
const CONSENT_KEY = 'dwish:lp-consent';

export type Consent = 'all' | 'necessary';
type Ym = ((...args: unknown[]) => void) & { a?: unknown[]; l?: number };
declare global {
  interface Window {
    ym?: Ym;
  }
}

let started = false;

export function getConsent(): Consent | null {
  try {
    const value = localStorage.getItem(CONSENT_KEY);
    return value === 'all' || value === 'necessary' ? value : null;
  } catch {
    return null;
  }
}

export function setConsent(value: Consent): void {
  try {
    localStorage.setItem(CONSENT_KEY, value);
  } catch {
    /* приватный режим: выбор живёт до перезагрузки */
  }
}

export function startMetrika(): void {
  if (started || import.meta.env.DEV || typeof window === 'undefined') return;
  started = true;
  const ym: Ym = (...args) => {
    (ym.a = ym.a ?? []).push(args);
  };
  ym.l = Date.now();
  window.ym = ym;
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://mc.yandex.ru/metrika/tag.js?id=${COUNTER_ID}`;
  document.head.appendChild(script);
  ym(COUNTER_ID, 'init', {
    ssr: true,
    webvisor: true,
    clickmap: true,
    ecommerce: 'dataLayer',
    referrer: document.referrer,
    url: location.href,
    accurateTrackBounce: true,
    trackLinks: true,
  });
}

/** Сразу после загрузки страницы, чтобы счётчик не мешал первому показу. */
export function startMetrikaAfterLoad(): void {
  const run = () => setTimeout(startMetrika, 0);
  if (document.readyState === 'complete') run();
  else window.addEventListener('load', run, { once: true });
}

/** Переход внутри сайта без перезагрузки: Метрика сама его не увидит. */
export function trackPage(url: string, referer: string): void {
  if (started) window.ym?.(COUNTER_ID, 'hit', url, { title: document.title, referer });
}

export function trackGoal(goal: string): void {
  if (started) window.ym?.(COUNTER_ID, 'reachGoal', goal);
}
